import { render, staticRenderFns } from "./Reconocimiento.vue?vue&type=template&id=88d3b2a6&scoped=true&"
var script = {}
import style0 from "./Reconocimiento.vue?vue&type=style&index=0&id=88d3b2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d3b2a6",
  null
  
)

export default component.exports